"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentStructureFixerSymbol = exports.ViewerManagerStructureAPISymbol = void 0;
exports.ViewerManagerStructureAPISymbol = Symbol('viewerManagerStructureApi');
exports.ComponentStructureFixerSymbol = Symbol('ComponentStructureFixer');
//# sourceMappingURL=viewerManagerStructureApi.js.map